import type { ReactNode } from 'react';
import { cn } from '@shared/lib/cn';

interface ChartCardProps {
  title: string;
  /** One line saying what the reader is looking at, including any caveat. */
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Shared frame so every chart on the page has the same heading rhythm. */
export function ChartCard({ title, description, action, children, className }: ChartCardProps) {
  return (
    <section className={cn('rounded-xl border border-slate-200 bg-white p-3.5', className)}>
      <header className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="truncate text-sm font-semibold text-slate-900">{title}</h2>
          {description && <p className="mt-0.5 truncate text-[11px] text-slate-400">{description}</p>}
        </div>
        {action}
      </header>

      {children}
    </section>
  );
}
